import { createFileRoute } from "@tanstack/react-router";
import { catalogDogAboutRoute } from "@/app-clients/catalog-detail/dog-route-data";
import { DogRouteNotFound } from "@/app-clients/catalog-detail/dog-route-not-found";
import { DogAboutPage } from "@/app-clients/catalog-detail/dog-about-page";

export const Route = createFileRoute("/_find/dog/$dogId_/about")({
    loader: catalogDogAboutRoute.loader,
    head: catalogDogAboutRoute.head,
    component: DogAboutPage,
    notFoundComponent: DogRouteNotFound,
});
